import ProjectView from "../../project-view"
import ProjectViews from "../../project-views"
import {ProjectViewConfig} from "../../@types";

export default class ProjectView_Everything extends ProjectView {

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        this.showInSubmenu = false


    }
}